module.exports = __webpack_public_path__ + "static/lighthouse-performance-9b8eb144357433bec7460b436894c963.jpg";